var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "feature-section-card-wrapper d-flex flex-column align-items-center position-relative",
      class: _vm.reverse ? "flex-md-row-reverse" : "flex-md-row",
    },
    [
      _c(
        "div",
        {
          staticClass: "text-box-wrapper flex-grow-1",
          class: _vm.reverse ? "text-box-wrapper-revers" : null,
        },
        [
          _c(
            "div",
            { staticClass: "text-box" },
            [
              _vm.icon && _vm.name
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "title-wrapper d-flex align-items-center",
                      },
                      [
                        _c("img", { attrs: { src: _vm.icon, alt: "icon" } }),
                        _c(
                          "p",
                          {
                            staticClass: "text-box-title font-outfit-semi-bold",
                            class: _vm.classColor,
                          },
                          [_vm._v(" " + _vm._s(_vm.name) + " ")]
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _c(
                "p",
                { staticClass: "text-box-subtitle font-outfit-semi-bold" },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
              _c("p", { staticClass: "text-box-description" }, [
                _vm._v(" " + _vm._s(_vm.description) + " "),
              ]),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "video-wrapper" },
        [
          _c("video-player", {
            attrs: {
              "video-name": _vm.videoName,
              muted: "",
              controls: false,
              autoplay: "",
              loop: "",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }